module.exports = __webpack_public_path__ + "./images/998ec5b3418b0f40bc60d8601d667713.png";